import { styled } from 'styled-components';

export const StyledGlobalSearch = styled.div`
  margin: 0 ${({ theme }) => theme.sizing.medium} 0 auto;
  padding-right: ${({ theme }) => theme.sizing.xxlarge};

  div[role='progressbar'] {
    border-color: ${({ theme }) => theme.colours.ink.primary.main};
    border-top-color: transparent !important;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    > div {
      width: 18rem;
    }
  }
`;
StyledGlobalSearch.displayName = 'StyledGlobalSearch';

export const StyledSearch = styled.div`
  margin-bottom: ${({ theme }) => theme.sizing.medium};

  input.prompt {
    padding-top: ${({ theme }) => theme.sizing.xsmall};
    padding-bottom: ${({ theme }) => theme.sizing.xsmall};
    border: none;
    background-color: ${({ theme }) =>
      theme.colours.layering[0].main} !important;
    color: ${({ theme }) => theme.colours.ink.primary.main} !important;

    :focus {
      background-color: ${({ theme }) => theme.colours.layering[0].main};
    }
  }

  input ~ i.icon {
    color: ${({ theme }) => theme.colours.ink.primary.main};
  }

  .results {
    background-color: ${({ theme }) =>
      theme.colours.canvas.tertiary.main} !important;
    box-shadow: ${({ theme }) =>
      theme.isDark ? 'none' : theme.effects.dropShadow.regular};
    overflow-y: scroll;
    max-height: 300px;
    border: 0 !important;
    border-radius: 0 !important;

    .result {
      height: 1.875rem;
      line-height: 2;
      padding: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;

      &:hover,
      &.active {
        background: ${({ theme }) =>
          theme.colours.canvas.secondary.strong} !important;
        color: ${({ theme }) => theme.colours.ink.primary.main} !important;
      }

      a {
        background: none;
        justify-content: flex-start;
        padding: ${({ theme }) =>
          `${theme.sizing.xtiny} ${theme.sizing.regular}`};
        color: ${({ theme }) => theme.colours.ink.primary.main} !important;
        text-decoration: none;

        &:hover {
          color: ${({ theme }) => theme.colours.ink.primary.main} !important;
        }
      }
    }
  }
`;
StyledSearch.displayName = 'StyledSearch';
